import Sampler from '../sampler';
import Recorder from '../recorder/recorder.vue';

navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

const families = [
  {
    id: 0,
    name: 'Keyboard'
  },
  {
    id: 1,
    name: 'Strings'
  },
  {
    id: 2,
    name: 'Woodwind'
  },
  {
    id: 3,
    name: 'Brass'
  },
  {
    id: 4,
    name: 'Special',
    disabled: true
  }
];

const sounds = [
  {
    name: 'Grand Piano',
    value: 'piano.mp3',
    family: 0
  },
  {
    name: 'Guitar',
    value: 'guitar.mp3',
    family: 1
  },
  {
    name: 'Bass',
    value: 'bass.mp3',
    family: 1
  },
  {
    name: 'Banjo',
    value: 'banjo.mp3',
    family: 1
  },
  {
    name: 'Viola',
    value: 'viola.mp3',
    family: 1
  },
  {
    name: 'Violin',
    value: 'violin.mp3',
    family: 1
  },
  {
    name: 'Cello',
    value: 'cello.mp3',
    family: 1
  },
  {
    name: 'Clarinet',
    value: 'clarinet.mp3',
    family: 2
  },
  {
    name: 'Bassoon',
    value: 'bassoon.mp3',
    family: 2
  },
  {
    name: 'Contrabassoon',
    value: 'contrabassoon.mp3',
    family: 2
  },
  {
    name: 'Saxophone',
    value: 'saxophone.mp3',
    family: 3
  },
  {
    name: 'French horn',
    value: 'french-horn.mp3',
    family: 3
  },
  {
    name: 'Trombone',
    value: 'trombone.mp3',
    family: 3
  },
  {
    name: 'Trumpet',
    value: 'trumpet.mp3',
    family: 3
  },
  {
    name: 'My own (open file)',
    value: 'open-file',
    family: 4,
    disabled: true
  },
  {
    name: 'Record',
    value: 'record',
    family: 4,
    disabled: true
  }
];

const enabledFamilies = families.filter(family => !family.disabled);
const enabledSounds = sounds.filter(sound => !sound.disabled);

export default {
  components: { Recorder },
  data () {
    return {
      sound: 'piano.mp3',
      families: enabledFamilies,
      sounds: enabledSounds
    };
  },

  computed: {
    canShowFileInput () {
      return this.sound === 'open-file';
    },
    canShowRecorder () {
      return this.sound === 'record' && navigator.getUserMedia;
    }
  },

  methods: {
    loadSound () {
      const disallowedSounds = ['open-file', 'record'];

      if (disallowedSounds.indexOf(this.sound) !== -1) {
        return;
      }

      const soundPath = Sampler.makePathFromSoundName(this.sound);

      Sampler.loadSound(soundPath);
    },

    readFile (file) {
      const fileReader = new FileReader();

      fileReader.onload = function (event) {
        const arrayBuffer = event.target.result;

        Sampler.loadArrayBuffer(arrayBuffer);
      };

      fileReader.readAsArrayBuffer(file);
    },

    filteredSounds (familyId) {
      // filterBy f.id in 'family'
      return this.sounds.filter(sound => {
        return sound.family === familyId;
      });
    },

    fileOpen (event) {
      const file = event.target.files[0];

      if (file.type.indexOf('audio') !== -1) {
        this.readFile(file);
      } else {
        alert('Not an audio file.'); // eslint-disable-line
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/sound-selector/sound-selector.js